import { ValuePeriod } from '#domain/types'

const DAYS_PER_YEAR = 365.2422
const WEEKS_PER_YEAR = DAYS_PER_YEAR / 7
const BIWEEKS_PER_YEAR = WEEKS_PER_YEAR / 2

const VALUE_PERIOD_MULTIPLIER: Record<ValuePeriod, number> = {
  [ValuePeriod.YEARLY]: 1,
  [ValuePeriod.QUARTERLY]: 4,
  [ValuePeriod.MONTHLY]: 12,
  [ValuePeriod.BIWEEKLY]: BIWEEKS_PER_YEAR,
  [ValuePeriod.WEEKLY]: WEEKS_PER_YEAR,
  [ValuePeriod.DAILY]: DAYS_PER_YEAR,
}

export const toAnnualValue = (
  value: number,
  valuePeriod: ValuePeriod
): number => value * (VALUE_PERIOD_MULTIPLIER[valuePeriod] ?? 1)

export default VALUE_PERIOD_MULTIPLIER
